import { Box, Typography } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { RouteMap } from '@/routes/Routes';
import { useAuthStore } from '@/stores/authStore';
import { hasBetaProductName } from '@/utils/subscriptionHelpers';
import { useCurrentPlanFeatures } from '@/hooks/useCurrentPlanFeatures';
import ModelGuidanceForm from './components/ModelGuidanceForm';
import CustomModelSelector from './components/CustomModelSelector';
import { useModelGuidance } from './hooks/useModelGuidance';
import { useUserModelSelection } from './hooks/useUserModelSelection';

const AboutMePage = () => {
  const { userData } = useAuthStore();
  const { betaFeatures, isLoading: isPlanLoading } = useCurrentPlanFeatures();
  const { value, onChange, onSave, isSaving, isDirty, maxLength } = useModelGuidance();
  const { models, isLoadingModels, selectedModelId, isSavingSelection, onSelectModel } = useUserModelSelection();

  if (!hasBetaProductName(userData) && !betaFeatures.aboutMeGuidance && !isPlanLoading) {
    return <Navigate to={RouteMap.HOME} replace />;
  }

  return (
    <Box
      px={{ xs: '16px', sm: '32px' }}
      py="24px"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '900px',
        mx: 'auto',
        gap: 3,
      }}
    >
      <Box>
        <Typography variant="h4" sx={{ mb: 1, fontWeight: 600 }}>
          Custom Guidance
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 0.5 }}>
          We are testing a feature where you can tell NoteGo models a little about your work to help guide them.
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          Share a short introduction below to personalize your experience.
        </Typography>
      </Box>

      <CustomModelSelector
        models={models}
        isLoading={isLoadingModels}
        selectedModelId={selectedModelId}
        isSaving={isSavingSelection}
        onSelect={(modelId) => {
          void onSelectModel(modelId);
        }}
      />

      <ModelGuidanceForm
        value={value}
        onChange={onChange}
        onSave={onSave}
        isSaving={isSaving}
        isDirty={isDirty}
        maxLength={maxLength}
      />

      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        Have feedback on this beta feature? Contact support and mention you&apos;re a beta tester.
      </Typography>
    </Box>
  );
};

export default AboutMePage;
